import axios, { type AxiosRequestHeaders } from 'axios';

async function get<T>(url: string, headers?: AxiosRequestHeaders): Promise<T> {
    const { data } = await axios.get(url, { headers: { ...headers } });
    return data;
}

async function post<T>(url: string, data: unknown, headers?: AxiosRequestHeaders): Promise<T> {
    const raw = await axios.post(url, data, { headers: { ...headers } });
    const { data: response } = raw;
    return response;
}

export { get, post };
